'use strict';

angular
  .module('cdPay.models')
  .factory('Contributions', ($resource) =>
    $resource(`${cdPay.config.api.payments}/payments/:id`)
  );
